var _effectorFileName = "/src/features/quiz/model.ts";
import { createEvent, sample } from 'effector';
import { getRoadmapQuery } from '@/shared/api/get-roadmap/api';
export const onGetRoadmapButtonClicked = createEvent<string>({
  loc: {
    file: _effectorFileName,
    line: 5,
    column: 41
  },
  name: "onGetRoadmapButtonClicked",
  sid: "idwx7s"
});
sample({
  and: [{
    clock: onGetRoadmapButtonClicked,
    target: getRoadmapQuery.start
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 7,
      column: 0
    },
    sid: "39lv4n"
  }
});
export const onGetWorkbookButtonClicked = createEvent<string>({
  loc: {
    file: _effectorFileName,
    line: 12,
    column: 42
  },
  name: "onGetWorkbookButtonClicked",
  sid: "-vnrqcb"
});
sample({
  and: [{
    clock: onGetWorkbookButtonClicked,
    target: getRoadmapQuery.start
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 14,
      column: 0
    },
    sid: "rj1odh"
  }
});